import { Component, OnDestroy, OnInit, computed } from "@angular/core";
import { NgFor, NgIf } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { MatchesService } from "../../services/matches.service";
import { TawkService } from "../../services/tawk.service";
import { Profile } from "../../models/profile";

@Component({
  selector: "app-chat-page",
  standalone: true,
  imports: [NgIf, NgFor, MatCardModule, MatButtonModule, MatIconModule],
  templateUrl: "./chat-page.component.html",
  styleUrl: "./chat-page.component.scss"
})
export class ChatPageComponent implements OnInit, OnDestroy {
  readonly matches = this.matchesService.matches;
  readonly count = computed(() => this.matches().length);
  readonly lastMessage = this.tawk.lastMessage;

  constructor(
    private readonly matchesService: MatchesService,
    private readonly tawk: TawkService,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    await this.tawk.load();
    const openFromQuiz = this.route.snapshot.queryParamMap.get("openChat") === "1";
    if (openFromQuiz) {
      this.tawk.openChat();
      void this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { openChat: null },
        queryParamsHandling: "merge",
        replaceUrl: true
      });
    } else {
      this.tawk.hide();
    }
  }

  ngOnDestroy(): void {
    this.tawk.hide();
  }

  clear(): void {
    this.matchesService.clear();
  }

  async openMatch(_match: Profile): Promise<void> {
    await this.tawk.load();
    this.tawk.openChat();
  }
}

